<template>
  <div class="settings-home container">
    <h1>Command Center</h1>
    <div v-for="parent in navItems" :key="parent.label" class="mb-5">
      <h4 class="text-secondary-emphasis">{{ parent.label }}</h4>
      <div @click="goto(nav.routeName)"
           class="pointer card shadow-sm mx-0 mx-sm-3 bg-light mb-3" v-for="nav in parent.children" :key="nav.label">
        <div class="card-body position-relative">
          <span class="text-secondary card-icon"><i class="bi bi-arrow-right"></i></span>
          <h5 class="card-title">
            <i class="bi me-2 text-secondary" :class="nav.icon"></i>
            {{nav.label}}
          </h5>
          <p class="card-text">{{nav.description}}</p>
        </div>
      </div>
    </div>
  </div>

</template>
<script setup>

import { defineProps } from "vue";
import { useRouter } from "vue-router";
defineProps(['navItems'])
const router = useRouter()

function goto(routeName) {
  router.push({ name: routeName })
}
</script>

<style lang="scss" scoped>
.settings-home {
  .card-text {
    margin-left: 32px;
  }
}

</style>